import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

const MainAdUnitContainer = styled.div`
  && {
    display: none;

    @media (min-width: ${breakpoints.lg}px) {
      display: block;
      border-top: 1px solid ${({ theme }) => theme.colors.greyDark};
      padding: 24px 0;
    }
  }
`;

export default MainAdUnitContainer;
